'use strict'

import productMock from './mock-data/product'

const mockMode = process.env.MOCKMODE

export function productService (http) {
	const service = {
		// Load all products
		findAll: async function () {
			if (!mockMode) {
				return http.jsonrpc(
					'/rpc/public/products',
					'findAll',
					[]
				).then(function (resp) {
					return resp.result
				})
			} else {
				return productMock
			}
		},
		// Load product by sku
		findBySKU: function (productSKU) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'findBySKU',
				[ productSKU ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Add new product
		insert: function (data) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'insert',
				[ data ]
			).then(function (resp) {
				return resp.result
			})
		},
		// save product changes
		update: function (product) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'update',
				[ product ]
			).then(function (resp) {
				return resp.result
			})
		}
	}

	return service
}



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/product-service.js